var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisibleDownloadButton)?_c('el-button',{on:{"click":_vm.onButtonClick}},[_vm._v("\n  "+_vm._s(_vm.$t('labels.download_users'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }